import { Link } from "@/components/common/Link";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Building2, Hammer, Droplets, Brush, ArrowRight, Trash2, Wrench, Bed, Phone, MessageCircle } from "lucide-react";
const services = [{
  title: "Outdoor Assembly",
  description: "Expert setup for Sacramento patios and backyards. From gazebos to play sets, we handle the heavy lifting and complex instructions so you can enjoy your outdoor oasis.",
  icon: Hammer
}, {
  title: "Furniture Assembly",
  description: "Stress-free assembly for IKEA, Amazon, and Wayfair furniture in Sacramento. Our professional team handles the tools and details, ensuring every piece is sturdy and ready for use.",
  icon: Building2
}, {
  title: "Floor & Carpet Removal",
  description: "Professional removal of old flooring and carpets across Sacramento. We efficiently clear your space, leaving it clean and ready for your next project without the mess.",
  icon: Trash2
}, {
  title: "Deep Carpet Cleaning",
  description: "Revitalize your Sacramento home with professional deep cleaning. We remove deep-seated dirt and allergens, extending the life of your carpets and improving indoor air quality.",
  icon: Droplets
}, {
  title: "Wood Floor Treatment",
  description: "Restore the natural beauty of your Sacramento hardwood with professional polishing and maintenance. Note: We specialize in treatment only, not new installations.",
  icon: Brush
}, {
  title: "Floor Repairs",
  description: "Restore the integrity of your Sacramento home's surfaces with expert patching and restoration services that match textures and finishes seamlessly.",
  icon: Wrench
}, {
  title: "Custom Bed Setup",
  description: "Specialized bed and frame assembly services ensuring structural stability and professional finish for your Sacramento bedroom renewal.",
  icon: Bed
}];
export default function OurProfessionalCraftsmanship() {
  return <section data-section-id="150929" id="our-professional-installation-expertise" className="py-24 bg-background text-foreground relative overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center mb-16 md:mb-24">
          <h2 className="text-3xl md:text-5xl font-default font-bold text-foreground mb-6 tracking-tighter uppercase">
            Our Professional Assembly & Removal Expertise
          </h2>
          <p className="text-lg text-muted-foreground leading-relaxed font-default">Kim &amp; Julio Home Renewals brings white-glove service to Sacramento. From professional floor removal to complex furniture assembly, we ensure every detail is handled with precision.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8 pb-12 items-start">
          {services.map((service, i) => <Link key={i} to="#" data-index={i} className="block h-full group outline-none focus-visible:ring-2 focus-visible:ring-ring rounded-xl lg:[&:nth-child(3n-1)]:translate-y-16 transition-transform duration-500">
              <Card className="h-full flex flex-col bg-card border-border/10 shadow-sm hover:shadow-xl transition-all duration-500 group-hover:bg-accent/30 group-hover:border-primary/20">
                <CardHeader className="pb-4">
                  <div className="mb-6 inline-flex items-center justify-center rounded-lg bg-background p-3 shadow-xs border border-border/10 w-fit group-hover:scale-110 transition-transform duration-500 ease-out">
                    <service.icon className="size-12 text-primary stroke-[1.5]" />
                  </div>
                  <CardTitle className="text-2xl font-default font-bold text-foreground group-hover:text-primary transition-colors duration-300">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="flex-1 flex flex-col">
                  <p className="text-muted-foreground leading-relaxed mb-8 font-default">
                    {service.description}
                  </p>
                  
                  <div className="mt-auto flex items-center text-primary font-mono text-xs tracking-widest uppercase">
                    <span className="relative overflow-hidden flex items-center">
                      Learn More
                      <ArrowRight className="size-4 ml-2 opacity-0 -translate-x-4 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300 ease-out" />
                    </span>
                  </div>
                </CardContent>
              </Card>
            </Link>)}
        </div>

        {}
        <div className="mt-24 flex flex-col sm:flex-row items-center justify-center gap-6">
          <Button asChild size="lg" className="w-full sm:w-auto rounded-full px-8 py-6 text-lg font-bold shadow-lg hover:shadow-primary/20 transition-all duration-300">
            <Link to="tel:+16105498900">
              <Phone className="mr-2 size-5" />
              Call Now
            </Link>
          </Button>
          <Button asChild variant="outline" size="lg" className="w-full sm:w-auto rounded-full px-8 py-6 text-lg font-bold border-2 border-primary text-primary hover:bg-primary/5 transition-all duration-300">
            <Link to="https://wa.me/16105498900?text=Hi%20I%20need%20free%20estimate">
              <MessageCircle className="mr-2 size-5" />
              Message on WhatsApp
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}